export const logRocketId = "b1tofo/thetanuts-finance";
